import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApolloClient } from '@apollo/client'
import { ApolloProvider } from '@apollo/client/react'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/carousel/styles.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { linkChain } from './graphql/links/chain'
import tunistryCache from './graphql/TunistryCache'

const client = new ApolloClient({
    link: linkChain,
    cache: tunistryCache,
    connectToDevTools: true
})
global.apolloClient = client

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <MantineProvider defaultColorScheme="dark" theme={{
          primaryColor: 'indigo',
          defaultRadius: 'md',
          fontSizes: {
              xs: '12px',
              sm: '14px',
              md: '16px',
              lg: '18px',
              xl: '20px',
          },
          components: {
              Modal: {
                  styles: (theme) => ({
                      header: {
                          backgroundColor: theme.colors.dark[5]
                      },
                  }),
              },
              TextInput: {
                  defaultProps: {
                      size: 'md',
                  },
                  styles: {
                      input: {
                          fontSize: '16px',
                      },
                  },
              },
              PasswordInput: {
                  defaultProps: {
                      size: 'md',
                  },
                  styles: {
                      input: {
                          fontSize: '16px',
                      },
                  },
              },
              Input: {
                  defaultProps: {
                      size: 'md',
                  },
                  styles: {
                      input: {
                          fontSize: '16px',
                      },
                  },
              },
          }
      }}>
          <Notifications position="bottom-right" zIndex={10001} />
          <ApolloProvider client={client}>
              <App />
          </ApolloProvider>
      </MantineProvider>
      </GoogleOAuthProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
